<template>
        <div v-if="options_loaded && passed_filter && panel_required" class="designeroption" :id="'radio--' + component_id">
            <div class="radiooption stylesoption" v-if="!loading" :data-designer-component-id="component_id">
                <span>{{ title }}: </span>
                <span v-for="option in filtered_option_list"><label><input type="radio" v-model="localTarget"
                                                                           :name="'radio_' + component_id"
                                                                           :value="option.value"/> {{ option.label }}</label></span>
            </div>
            <div v-if="loading">
                <p>Loading Options</p>
            </div>
        </div>
</template>

<script type="text/ecmascript-6">
    import RadioQuestion from "./mixin/RadioQuestion.vue";

    export default {
        mixins: [
            RadioQuestion
        ],
        props: {
            title: {
                default(){
                    return 'Restrictor';
                }
            },
            component_id: {
                default(){
                    return 'restrictor';
                }
            },
            openingDirection: {
                default(){
                    return '';
                }
            },
            slab: {
                default(){
                    return '';
                }
            },
            amount_of_options_required_to_show: {
                required: false,
                default(){
                    return 2;
                }
            }
        },
        computed: {
            passed_filter(){
                return this.variable_ready();
            },
            url(){
                return '/api/options/' + this.fabricator + '/restrictor' + '?opening_direction=' + this.openingDirection + '&slab=' + this.slab;
            },
            cache_key(){
                return '_' + this.openingDirection + '_' + this.slab;
            },
            panel_required(){
                return this.filtered_option_list.length >= this.amount_of_options_required_to_show;
            }
        },
        watch: {
            'cache_key': function (val, oldVal) {
                this.update_options();
            }
        }
    }
</script>
